import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchTypes () {
  return axios
    .get(`${CRM_API_URL}/connectors/types`)
    .then((response) => response.data)
}

export default { fetchTypes }
